import React from 'react';
import styled from 'styled-components';
import { Image } from 'UI-Dash-Commons-UI';
import SectionUtils from '../utils/SectionUtils';
import MenuSpec from "../../../types/MenuSpec";
import MenuSection from "../../../types/MenuSection";

type TopButtonsMenuComponentProps =
    {
        menuSpec: MenuSpec | null,
        onSectionActivated: ( sectionSpec: MenuSection ) => void
    };

const TopButtonsMenuComponent: React.StatelessComponent<TopButtonsMenuComponentProps> = ( {
                                                                                              menuSpec,
                                                                                              onSectionActivated
                                                                                          } ) =>
{

    if ( !menuSpec || !menuSpec.menu || !menuSpec.menu.length )
    {
        return null;
    }

    return <TopButtonsWrapper>
        {( menuSpec.menu.map( ( childMenuSpec ) => (
            <TopButton
                onClick={() => onSectionActivated( childMenuSpec )}
                height={'24px'}
                src={SectionUtils.findImage( childMenuSpec.sectionId, true )}
                alt={childMenuSpec.displayName}
                key={childMenuSpec.sectionId}
            >

            </TopButton>
        ) ) )}
    </TopButtonsWrapper>;
};

const TopButtonsWrapper = styled.div`  
  display: flex;
  flex-direction: row;
  justify-content: flex-start;

  margin-top: 12px;
  margin-right: 20px;  
`;

const TopButton = styled( Image )`
  margin-right: 10px;

  cursor: pointer;  
  opacity: 0.9;
`;

export default TopButtonsMenuComponent;
